/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import { useNavigate } from 'react-router-dom'

import Menu from '../../../../components/CustomerClub/Menu'
import Table from '../../../../components/CustomerClub/CCUsersList'

import TableSite from '../../../../components/UsersList'

import userIcon from '../../../../assets/svg/userIcon.svg'
import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  document.title = 'مشتریان'

  const [users, setUsers] = useState()
  const [usersCount, setUsersCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const [usersSite, setUsersSite] = useState()
  const [usersCountSite, setUsersCountSite] = useState()
  const [totalPageSite, setTotalPageSite] = useState()

  const navigate = useNavigate()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/ccusers?token=${token}`)
      .then(response => {
        setUsers(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setUsersCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/users?token=${token}`)
      .then(response => {
        setUsersSite(response.data.data.docs)
        setTotalPageSite(response.data.data.pages)
        setUsersCountSite(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/ccusers?page=${event.selected + 1}&token=${token}`)
      .then(respose => {
        setUsers(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setUsersCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  const navigateHandler = () => {
    navigate('/cc/users/create')
  }

  const handlePageClickSite = (event) => {
    get(`/api/admin/users?page=${event.selected + 1}&token=${token}`)
      .then(response => {
        setUsersSite(response.data.data.docs)
        setTotalPageSite(response.data.data.pages)
        setUsersCountSite(response.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'user'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={userIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست مشتریان
              </div>
            </div>
            <div className="left">
              <button onClick={navigateHandler}>ایجاد مشتری</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل‌مشتریان
              </div>
              <div className="left">
                {usersCount}
              </div>
            </div>

            <Table data={users}/>
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کاربران سایت
              </div>
              <div className="left">
                {usersCountSite}
              </div>
            </div>

            <TableSite data={usersSite}/>
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClickSite}
              pageRangeDisplayed={5}
              pageCount={totalPageSite}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
